import axiosWrapper from '../helpers/api'
import { ERequestUrl, EMethods } from '../helpers/requests'

export const getParameters = () =>
  axiosWrapper({
    method: EMethods.get,
    url: ERequestUrl.root,
    uid: `brand/parameters`,
  })
